// This file is auto-generated by @hey-api/openapi-ts

type Slot = 'body' | 'headers' | 'path' | 'query';

export type Field =
  | {
      in: Exclude<Slot, 'body'>;
      /**
       * Field name. This is the name we want the user to see and use.
       */
      key: string;
      /**
       * Field mapped name. This is the name we want to use in the request.
       * If omitted, we use the same value as `key`.
       */
      map?: string;
    }
  | {
      in: Extract<Slot, 'body'>;
      /**
       * Key isn't required for bodies.
       */
      key?: string;
      map?: string;
    }
  | {
      /**
       * Field name. This is the name we want the user to see and use.
       */
      key: string;
      /**
       * Field mapped name. This is the name we want to use in the request.
       * If `in` is omitted, `map` aliases `key` to the transport layer.
       */
      map: Slot;
    };

export interface Fields {
  allowExtra?: Partial<Record<Slot, boolean>>;
  args?: ReadonlyArray<Field>;
}

export type FieldsConfig = ReadonlyArray<Field | Fields>;

const extraPrefixesMap: Record<string, Slot> = {
  $body_: 'body',
  $headers_: 'headers',
  $path_: 'path',
  $query_: 'query',
};
const extraPrefixes = Object.entries(extraPrefixesMap);

type KeyMap = Map<
  string,
  | {
      in: Slot;
      map?: string;
    }
  | {
      in?: never;
      map: Slot;
    }
>;

const buildKeyMap = (fields: FieldsConfig, map?: KeyMap): KeyMap => {
  map ??= new Map();

  for (const config of fields) {
    if ('in' in config) {
      if (config.key) {
        map.set(config.key, {
          in: config.in,
          ...(config.map !== undefined ? { map: config.map } : {}),
        });
      }
    } else if ('key' in config) {
      map.set(config.key, {
        map: config.map,
      });
    } else if (config.args) {
      buildKeyMap(config.args, map);
    }
  }

  return map;
};

interface Params {
  body: unknown;
  headers: Record<string, unknown>;
  path: Record<string, unknown>;
  query: Record<string, unknown>;
}

const stripEmptySlots = (params: Params) => {
  for (const [slot, value] of Object.entries(params)) {
    if (value && typeof value === 'object' && !Array.isArray(value) && !Object.keys(value).length) {
      delete params[slot as Slot];
    }
  }
};

function writeExtraParam(params: Params, config: FieldsConfig[number], key: string, value: unknown): void {
  const extra = extraPrefixes.find(([prefix]) => key.startsWith(prefix));
  if (extra) { ensureSlot(params, extra[1])[key.slice(extra[0].length)] = value; return; }
  if ('allowExtra' in config && config.allowExtra) {
    const slot = (Object.entries(config.allowExtra) as Array<[Slot, boolean]>).find(([, allowed]) => allowed)?.[0];
    if (slot) ensureSlot(params, slot)[key] = value;
  }
}

function ensureSlot(params: Params, slot: Slot): Record<string, unknown> {
  const record = params[slot] as Record<string, unknown> | undefined;
  if (record) return record;
  const created = Object.create(null) as Record<string, unknown>;
  params[slot] = created;
  return created;
}

function writeMappedParam(params: Params, map: KeyMap, config: FieldsConfig[number], arg: unknown): void {
  if ('in' in config) {
    if (!config.key) { params.body = arg; return; }
    const field = map.get(config.key);
    if (field?.in) ensureSlot(params, field.in)[field.map || config.key] = arg;
    return;
  }
  for (const [key, value] of Object.entries(arg ?? {})) {
    const field = map.get(key);
    if (field?.in) { ensureSlot(params, field.in)[field.map || key] = value; continue; }
    if (field) { params[field.map] = value; continue; }
    writeExtraParam(params, config, key, value);
  }
}

export function buildClientParams(args: ReadonlyArray<unknown>, fields: FieldsConfig): Params {
  const params: Params = {
    body: Object.create(null),
    headers: Object.create(null),
    path: Object.create(null),
    query: Object.create(null),
  };

  const map = buildKeyMap(fields);

  let config: FieldsConfig[number] | undefined;

  for (const [index, arg] of args.entries()) {
    if (fields[index]) {
      config = fields[index];
    }

    if (!config) {
      continue;
    }

    writeMappedParam(params, map, config, arg);
  }

  stripEmptySlots(params);

  return params;
};
